import { Enums } from '@/model/util'

import { DASHBOARD } from '@/routes/general'
import { ADMIN, ADMIN_DASHBOARD } from '@/routes/admin'
import { PRODUCTS, RECO } from '@/routes/product'
import { REPORTS, REPORTS_PERFORMANCE } from '@/routes/report'

import { SALES_POINTS, SALES_POINT_MAP } from '@/routes/sales-point'

import { axios } from '@woc/woc-repository'

export const BrandEnum = Enums.create('brandContext', {
  WOLF: Enums.value('wolf', 'brand.wolf',
    {
      appTitleKey: 'general.wolfTitle',
      logoPath: '/images/wolf-logo.png',
      coverPath: '/images/wolf-cover.jpg',
      androidAppUrl: 'https://play.google.com/store/apps/details?id=com.wolf.productreco',
      iosAppUrl: 'https://itunes.apple.com/us/app/wolflubes-lubricant-finder/id1421267905',
      primaryColor: '#00a3d3',
      secondaryColor: '#48ddff'
    }
  ),
  CHAMPION: Enums.value('champion', 'brand.champion',
    {
      appTitleKey: 'general.championTitle',
      logoPath: '/images/champion-logo.png',
      coverPath: '/images/champion-cover.jpg',
      androidAppUrl: 'https://play.google.com/store/apps/details?id=com.champion.productreco',
      iosAppUrl: 'https://itunes.apple.com/us/app/championlubes-lubricant-finder/id1421229681',
      primaryColor: '#cb0008',
      secondaryColor: '#ff575f'
    }
  )
})

function moduleEnum (id, enabled, options) {
  return Enums.value(id, undefined, Object.assign({ enabled }, options))
}

export const ApplicationModuleEnum = Enums.create('applicationModule', {
  DASHBOARD: moduleEnum('dashboard', true, { route: DASHBOARD, root: DASHBOARD }),
  ADMINISTRATION: moduleEnum('administration', true, { route: ADMIN_DASHBOARD, root: ADMIN, icon: 'download' }),
  COMPANY_SALES_POINTS: moduleEnum('company-sales-points', true, { route: SALES_POINT_MAP, root: SALES_POINTS, icon: 'pin' }),
  PRODUCTS: moduleEnum('products', true, { root: PRODUCTS, route: RECO, icon: 'oil-can' }),
  BYNDER: moduleEnum('bynder', true, { icon: 'download', infoKey: 'module.bynder.info' }),
  PARTNER_PLAN: moduleEnum('reports-insights', false, { route: REPORTS_PERFORMANCE, root: REPORTS, icon: 'partner-plan', infoKey: 'module.reports.info' }),
  E_COMMERCE: moduleEnum('e-commerce', false, { icon: 'basket', alias: 'magento', labelKey: 'module.eCommerce.title' })
})

export function getEnvironment () {
  let baseUrl = location.origin

  if (window._woc && window._woc.base) {
    const urlParts = window._woc.base.split('/')
    baseUrl = `${urlParts[0]}//${urlParts[2]}`
  }
  axios.defaults.baseURL = baseUrl
  axios.defaults.withCredentials = true

  const brand = baseUrl && baseUrl.match(/(champion|127)/) ? BrandEnum.values.CHAMPION : BrandEnum.values.WOLF
  return Object.assign({ baseUrl }, brand)
}
